import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";

import data from "../../../../assets/apiRoutes.json";
import axios from "axios";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import Toolbar, { Item } from "devextreme-react/toolbar";
import AccordionReact from 'devextreme-react/accordion';
import { TextBox, DateBox, SelectBox, CheckBox, Button, } from 'devextreme-react';

import {
    Column,
    DataGrid,
    LoadPanel as DataGridLoadPanel,
    ColumnChooser,
    ColumnChooserSearch,
    Scrolling,
    Export,
    Sorting,
    Paging,
    Pager,
    Toolbar as DataGridToolbar,
    Item as DataGridToolbarItem,
    Editing,
    FilterRow,
    FilterPanel,
    Lookup,
    StateStoring,
} from "devextreme-react/data-grid";
import { height } from "devexpress-dashboard/model/index.metadata";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


var LocationWHId = '';

const gridKey = "E6839B26-4EC3-40A2-A4B3-F86322006205";

function CountResults(props) {
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [reasonCodeLookup, setReasonCodeLookup] = useState([]);
    const [enterCounterdLookup, setEnterdCounterdLookup] = useState([]);
    const [refrencesLookup, setRefrencesLookup] = useState([]);
    const [selectedRefrence, setRefrence] = useState('');
    const [isLatest, setIsLatest] = useState(false);
    const [selectedDesc, setDesc] = useState('');
    const [varianceReasonCode, setVarianceReasonCodeLookup] = useState([]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [handleSearchClick, setHandleSearchClick] = useState(false);
    const [dataSourceGrid, setDataSourceGrid] = useState([]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const selectBoxRef = useRef(null);
    const [totalFinalInventoryQuantity, setTotalFinalInventoryQuantity] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);

        },
        [selectedItems, setSelectedItems],
    );


    const dataGrid = useRef(null);
    const handleCellValueChanged = (data) => {

        setSelectedItemKeys(data.selectedRowKeys);
    }

    const prefixData = [
        { ID: 'Y', Text: "Yes" },
        { ID: 'N', Text: "No" },
    ];

    const allowedPageSizes = [5, 10, 20,100, "all"];

    const handleReset = () => {
    };
    const resetItemSearcForm = (e) => {
        e.event.stopPropagation();
        setRefrence('');
        setDesc('');
        setHandleSearchClick(!handleSearchClick);
    };

    const onSubmit = async (e) => {
        e.event.stopPropagation();
        setDesc('');
        setHandleSearchClick(!handleSearchClick);
    };
    const latestCount = async (e) => {
        e.event.stopPropagation();
        var res = await axios.get
            (
                `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetLatestHeader}`,

                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
        setRefrence(res.data.id);
        setDesc(res.data.description);
        setHandleSearchClick(!handleSearchClick);
    };

    const renderLocatonsCell = (cellElement) => {
        const items = LoadLocations(LocationWHId)
        const currentValue = cellElement.data.locationCode;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Name"
                searchMode="contains"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                }}
            />
        );
    }
    const renderLocatonsWHCell = (cellElement) => {
        const items = LoadLocationsWH()
        const currentValue = cellElement.data.identityId;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Name"
                searchMode="contains"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                    LocationWHId = selectedRowId;
                }}
            />
        );
    }
    const renderCustomersCell = (cellElement) => {
        const items = LoadCustomers()
        const currentValue = cellElement.data.customerId;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Name"
                searchMode="contains"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                }}
            />
        );
    }

    const renderItemCell = (cellElement) => {
        const items = LoadItems(cellElement.data?.r_Identity);
        const currentValue = cellElement.data.itemCode;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Name"
                searchMode="contains"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                }}
            />
        );
    }
    const renderLotCell = (cellElement) => {
        const lots = LoadLots(cellElement.data?.r_Item)
        const currentValue = cellElement.data.lotCode;
        return (
            <SelectBox
                dataSource={lots}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                searchEnabled={true}
                searchMode="contains"
                searchExpr="Name"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                }}
            />
        );
    }
    const renderSubLotCell = (cellElement) => {
        const lots = LoadSubLots(cellElement.data?.r_Lot)
        const currentValue = cellElement.data.sublotCode;
        return (
            <SelectBox
                dataSource={lots}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                searchEnabled={true}
                searchMode="contains"
                searchExpr="Name"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                }}
            />
        );
    }
    const renderUnitCell = (cellElement) => {

        const units = LoadUnits(cellElement.data?.r_SubLot)
        const currentValue = cellElement.value;
        return (
            <SelectBox
                dataSource={units}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                searchEnabled={true}
                searchMode="contains"
                searchExpr="Name"
                onValueChanged={(e) => {

                    const selectedRowId = e.value; // Get the rowId from valueExpr
                    const selectedText = e.component.option('displayValue'); // Get display value
                    cellElement.setValue({ selectedText, selectedRowId }); // Update displayed value
                }}

            />
        );
    }


    const dataSource = createStore({
        key: 'rowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetCountResults}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.InsertOrderDetails}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.UpdateOrderDetails}`,
        loadParams: {
            isLatest: function () {
                return isLatest;
            },
            refrence: function () {
                return selectedRefrence;
            },
            description: function () {
                return selectedDesc;
            }
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                refrence: selectedRefrence
            };
        }
    });
    // Recreate when ROWID changes
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {

            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }

    }
    const handleCellPrepared = (e) => {
        if (e.rowType === 'data') {  // Only target data rows
            const isEditable = e.column.allowEditing;  // Check if the column is editable

            if (isEditable) {
                // Apply custom style for editable cells (e.g., white background)
                e.cellElement.style.backgroundColor = 'white';
            } else {
                // Apply custom style for non-editable cells (e.g., gray background)
                e.cellElement.style.backgroundColor = '#f2f2f2'; // Light gray for disabled cells
            }
        }
    };
    useEffect(() => {
        getReasonCodes();
        getEnterCounterdBy();
        getRefrences();
    }, []);
    useEffect(() => {
        const datasource = createStore({
            key: 'rowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetCountResults}`,
            insertUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.InsertOrderDetails}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.UpdateOrderDetails}`,
            loadParams: {
                refrence: function () {
                    return selectedRefrence;
                },
                description: function () {
                    return selectedDesc;
                }
            },
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`,
                    refrence: selectedRefrence
                };
            }
        });
        let desc= refrencesLookup.find(x=>x.id==selectedRefrence)?.description;
        setDesc(desc);
        setDataSourceGrid(datasource);
        getCountSum();
    }, [handleSearchClick]);

    const getReasonCodes = async () => {
        var res = await axios.get
            (
                `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetReasonsCodes}`,

                {
                    params: {
                        masterRowId: "02,84"
                    },
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
        const filteredVarianceData = res.data.filter((item) => item.codetype === '84');
        const filteredAvailableReasonCodeData = res.data.filter((item) => item.codetype === '02');
        // Set the filtered data in the state
        setVarianceReasonCodeLookup(filteredVarianceData);
        setReasonCodeLookup(filteredAvailableReasonCodeData);
    };
    const getEnterCounterdBy = async () => {
        var res = await axios.get
            (
                `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetCounterdEnterdBy}`,

                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
        setEnterdCounterdLookup(res.data.data);
    };
    const getCountSum = async () => {
        var res = await axios.get
            (
                `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetCountSum}`,

                {
                    params: { masterRowId: selectedRefrence },
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
        setTotalFinalInventoryQuantity(res.data);
    };
    const getRefrences = async () => {
        var res = await axios.get
            (
                `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetRefrencesList}`,

                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            );
        setRefrencesLookup(res.data);
    };
    const handleEditingStart = (e) => {
        if (e.key) { // Existing record (id exists)
            // Allow editing only for specific columns (these are editable)
            if (["finalInventoryQuantity", "piecesPerUnitQuantity", "unitsPerPackageQuantity", "packagesPerShippingUnitQty", "r_CountedBy", "r_EnteredBy", "varianceReasonCode", "comment", "availableFlag", "outUnavailable", "availableReasonCode", "unavailableComment", "outUnavailablePrior"].includes(e.column.dataField)) {
                e.cancel = false; // Allow editing for these columns
            } else {
                e.cancel = true; // Cancel editing for other columns
            }
        } else {
            // New record (no id), allow editing for specific columns, disable others
            if (["identityId", "countSheetPageNumber", "locationCode", "customerId", "itemCode", "lotCode", "sublotCode", "unitCode", "r_CountedBy", "r_EnteredBy", "varianceReasonCode", "comment", "availableFlag", "outUnavailable", "availableReasonCode", "unavailableComment", "outUnavailablePrior"].includes(e.column.dataField)) {
                e.cancel = false; // Allow editing for these columns
            } else {
                e.cancel = true; // Cancel editing for other columns
            }
        }
    };


    const refrencesData = new DataSource({
        store: createStore({
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetRefrences}`,
            key: 'id',
            loadParams: {
            },
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
        sort: [{ selector: "name", desc: false }],
        paginate: true,
        pageSize: 100
    });

    const LoadLocations = (locId) => {
        const selectBoxData = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetLocations}`,
                key: 'id',
                loadParams: {
                    masterRowId: function () {
                        return locId;
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return selectBoxData;
    };
    const LoadLocationsWH = () => {
        const selectBoxData = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetLocationsWH}`,
                key: 'id',
                loadParams: {
                    customerIdentity: '' // Pass your custom parameter here
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return selectBoxData;
    };
    const LoadCustomers = () => {
        const selectBoxData = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetCustomers}`,
                key: 'id',
                loadParams: {
                    customerIdentity: '' // Pass your custom parameter here
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            paginate: true,
            pageSize: 100
        });
        return selectBoxData;
    };
    // LoadItems function
    const LoadItems = (customerId) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.Item.GetItems}`,
                key: 'id',
                loadParams: {
                    customerIdentity: customerId // Pass your custom parameter here
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };
    // LoadLots function
    const LoadLots = (itemId) => {
        const lots = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.Lot.GetLots}`,
                key: 'id',
                loadParams: {
                    masterRowId: function () {
                        return itemId;
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return lots;
    };
    // LoadLots function
    const LoadSubLots = (lotId) => {
        const subLots = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetSubLots}`,
                key: 'id',
                loadParams: {
                    masterRowId: function () {
                        return lotId;
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return subLots;
    };
    const LoadUnits = (subLotId) => {
        const subLots = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.GenCountRecords.GetUnits}`,
                key: 'id',
                loadParams: {
                    masterRowId: function () {
                        return subLotId;
                    }
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return subLots;
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={selectionChanged}
                            className="accordion-height"
                            itemTitleRender={() => (
                                <Toolbar className="accordian-toolbar">
                                    <Item location="before">
                                        <div className="title">
                                            <h6
                                                style={{
                                                    color: window._env_.Color2
                                                }}
                                            >
                                                Enter Count Results
                                            </h6>
                                        </div>
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={latestCount} text="Latest Count" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={onSubmit} text="Search" type="default" />
                                    </Item>
                                    <Item location="after">
                                        <Button className="accordianButton" onClick={resetItemSearcForm} text="Reset" />
                                    </Item>
                                </Toolbar>

                            )}
                            itemRender={(itemProps) => (
                                <>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <SelectBox
                                                stylingMode='outlined'
                                                labelMode="static"
                                                dataSource={refrencesLookup}
                                                label="Refrence #"
                                                valueExpr="id"
                                                displayExpr="name"
                                                searchEnabled={true}
                                                searchMode="contains"
                                                value={selectedRefrence}
                                                searchExpr="name"
                                                onValueChanged={(e) => setRefrence(e.value)}
                                                variant="outlined"

                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <TextBox
                                                stylingMode='outlined'
                                                labelMode="static"
                                                label="Description"
                                                value={selectedDesc}
                                                onValueChanged={(e) => setDesc(e.value)}
                                                name="description"
                                                variant="outlined"

                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            id="accordion-container"
                        />
                        <div>
                            <DataGrid
                                id="gridContainer"
                                dataSource={dataSourceGrid}
                                ref={dataGrid}
                                selectedRowKeys={selectedItemKeys}
                                showBorders={true}
                                onSelectionChanged={handleCellValueChanged}
                                onRowUpdated={getCountSum}
                                rowAlternationEnabled={true}
                                remoteOperations={true}
                                allowColumnReordering={true}
                                allowColumnResizing={true}
                                columnAutoWidth={true}
                                className={selectedItems.length > 0 ? "GridHeightAccordianOpen-single-row" : "GridHeightAccordianClose"}
                                onEditingStart={handleEditingStart}
                                searchEnabled={true}
                                hoverStateEnabled={true}
                            // onRowUpdating={handleRowUpdating}
                            >
                                <Export enabled={true} allowExportSelectedData={true} />
                                <ColumnChooser
                                    enabled={true}
                                    title="Choose Column"
                                    width={290}
                                    height={290}
                                    sortOrder="asc"
                                >
                                    <ColumnChooserSearch
                                        enabled={true}
                                        editorOptions={{ placeholder: 'Search column' }} />
                                </ColumnChooser>
                                <Sorting visible={true} mode="multiple" />
                                <Paging defaultPageSize={10} />
                                <Pager
                                    visible={true}
                                    showPageSizeSelector={true}
                                    allowedPageSizes={allowedPageSizes}
                                    showNavigationButtons={true}
                                />
                                <Editing
                                    mode="cell"
                                    allowUpdating={true}
                                    allowAdding={true}
                                />
                                <StateStoring
                                    enabled={true}
                                    type="custom"
                                    customLoad={loadState}
                                    storageKey={gridKey}
                                    customSave={saveState}
                                />
                                <Scrolling rowRenderingMode="virtual" />
                                <FilterRow visible={true} />
                                <Scrolling mode="standard" />
                                <FilterPanel visible={true} />
                                <Column dataField="countSheetPageNumber" caption='PG' />
                                <Column dataField="identityId" caption='Warehouse' editCellRender={renderLocatonsWHCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.identityId = newValue.selectedText;
                                        rowData.locationCode = '';
                                        rowData.r_Location = '';
                                        // rowData.r_Location=newValue.selectedRowId;
                                    }} />
                                <Column dataField="r_Location" caption='Location ID' visible={false} />
                                <Column dataField="locationCode" caption='Location' editCellRender={renderLocatonsCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.locationCode = newValue.selectedText;
                                        rowData.r_Location = newValue.selectedRowId;
                                    }}
                                />
                                <Column dataField="r_Identity" caption='Customer ID' visible={false} />
                                <Column dataField="customerId" caption='Customer' editCellRender={renderCustomersCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.customerId = newValue.selectedText;
                                        rowData.r_Identity = newValue.selectedRowId;
                                        rowData.itemCode = '';
                                        rowData.r_Item = '';
                                    }} />
                                <Column dataField="r_Item" caption='Item Id' visible={false} />
                                <Column caption="Item" dataField="itemCode" editCellRender={renderItemCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.itemCode = newValue.selectedText;
                                        rowData.r_Item = newValue.selectedRowId;
                                    }} />
                                <Column dataField="r_Lot" caption='lot Id' visible={false} />
                                <Column caption="Lot" dataField="lotCode" editCellRender={renderLotCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.lotCode = newValue.selectedText;
                                        rowData.r_Lot = newValue.selectedRowId;
                                    }} />
                                <Column dataField="r_SubLot" caption='Sub lot Id' visible={false} />
                                <Column caption="SublotCode" dataField="sublotCode" editCellRender={renderSubLotCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.sublotCode = newValue.selectedText;
                                        rowData.r_SubLot = newValue.selectedRowId;
                                    }} />
                                <Column dataField="r_Unit" caption='Unit Id' visible={false} />
                                <Column caption="Unit" dataField="unitCode" editCellRender={renderUnitCell}
                                    setCellValue={(rowData, newValue) => {
                                        rowData.unitCode = newValue.selectedText;
                                        rowData.r_Unit = newValue.selectedRowId;
                                    }} />
                                <Column
                                    caption="Primary Pick Loc"
                                    dataField="PrimaryPickLoc"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                    allowEditing={false}
                                />
                                <Column
                                    caption="Quantity"
                                    dataField="inventoryQuantity"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                    allowEditing={false}
                                />
                                <Column
                                    caption="Count"
                                    dataField="finalInventoryQuantity"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}

                                />
                                <Column
                                    caption="Piece/Unit"
                                    dataField="piecesPerUnitQuantity"

                                ></Column>
                                <Column
                                    caption="Units/Pkg"
                                    dataField="unitsPerPackageQuantity"

                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                />
                                <Column
                                    caption="Pkg/Ship"
                                    dataField="packagesPerShippingUnitQty"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                />
                                <Column
                                    caption="invPiecesPerUnitQty"
                                    dataField="invPiecesPerUnitQty"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                    visible={false}
                                />
                                <Column
                                    caption="invUnitsPerPackageQty"
                                    dataField="invUnitsPerPackageQty"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                    visible={false}
                                />
                                <Column
                                    caption="InvPackagesPerShippingUnitQty"
                                    dataField="invPackagesPerShippingUnitQty"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                    visible={false}
                                />
                                <Column
                                    caption="Variance"
                                    dataField="variance"
                                    allowEditing={false}
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 4,
                                        useGrouping: true
                                    }}
                                    calculateCellValue={(rowData) => {
                                        const finalInventoryQuantity = rowData.finalInventoryQuantity ?? 0;
                                        const inventoryQuantity = rowData.inventoryQuantity ?? 0;
                                        const piecesPerUnitQuantity = rowData.piecesPerUnitQuantity ?? 0;
                                        const invPiecesPerUnitQty = rowData.invPiecesPerUnitQty ?? 0;
                                        const unitsPerPackageQuantity = rowData.unitsPerPackageQuantity ?? 0;
                                        const invUnitsPerPackageQty = rowData.invUnitsPerPackageQty ?? 0;
                                        const packagesPerShippingUnitQty = rowData.packagesPerShippingUnitQty ?? 0;
                                        const invPackagesPerShippingUnitQty = rowData.invPackagesPerShippingUnitQty ?? 0;

                                        // Calculate variances
                                        let variancePIECESPERUNITAmt = 0;
                                        let varianceUNITSPERPACKAGEAmt = 0;
                                        let variancePACKAGESPERSHIPPINGAmt = 0;

                                        if (piecesPerUnitQuantity !== 0 && invPiecesPerUnitQty !== 0) {
                                            variancePIECESPERUNITAmt = piecesPerUnitQuantity / invPiecesPerUnitQty;
                                        }

                                        if (unitsPerPackageQuantity !== 0 && invUnitsPerPackageQty !== 0) {
                                            varianceUNITSPERPACKAGEAmt = unitsPerPackageQuantity * invUnitsPerPackageQty;
                                        }

                                        if (
                                            packagesPerShippingUnitQty !== 0 &&
                                            invPackagesPerShippingUnitQty !== 0 &&
                                            invUnitsPerPackageQty !== 0
                                        ) {
                                            variancePACKAGESPERSHIPPINGAmt =
                                                packagesPerShippingUnitQty *
                                                invPackagesPerShippingUnitQty *
                                                invUnitsPerPackageQty;
                                        }

                                        let varianceAmt =
                                            finalInventoryQuantity - inventoryQuantity +
                                            variancePIECESPERUNITAmt +
                                            varianceUNITSPERPACKAGEAmt +
                                            variancePACKAGESPERSHIPPINGAmt;

                                        return varianceAmt !== 0 ? varianceAmt : null; // Return null if variance is 0
                                    }}
                                />
                                <Column dataField="r_CountedBy" caption='Counted By' visible={false}>
                                    <Lookup
                                        dataSource={enterCounterdLookup}
                                        displayExpr="name"
                                        valueExpr="id"
                                    />
                                </Column>
                                <Column dataField="r_EnteredBy" caption='Enterd By' visible={false} >
                                    <Lookup
                                        dataSource={enterCounterdLookup}
                                        displayExpr="name"
                                        valueExpr="id"
                                    />
                                </Column>
                                <Column
                                    caption="Reason"
                                    dataField="varianceReasonCode" visible={false}>
                                    <Lookup
                                        dataSource={varianceReasonCode}
                                        displayExpr="code"
                                        valueExpr="code"
                                    />
                                </Column>
                                <Column dataField="comment" caption='Comment' visible={false} />
                                <Column dataField="availableFlag" caption='Adj.Unavailable' visible={false} >
                                    <Lookup
                                        dataSource={prefixData}
                                        displayExpr="Text"
                                        valueExpr="ID"
                                    />
                                </Column>
                                <Column
                                    caption="Prior Unavailable"
                                    dataField="outUnavailablePrior" visible={false}
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                />
                                <Column
                                    caption="Unavailable"
                                    dataField="outUnavailable"
                                    format={{
                                        type: 'fixedPoint',
                                        precision: 2,
                                        useGrouping: true
                                    }}
                                />
                                <Column
                                    caption="Unavailable Reason"
                                    dataField="availableReasonCode" visible={false}>
                                    <Lookup
                                        dataSource={reasonCodeLookup}
                                        displayExpr="code"
                                        valueExpr="code"
                                    />

                                </Column>
                                <Column caption="Comment Unailable" dataField="unavailableComment" visible={false} />

                                <Column caption="Item Description-1" dataField="description1" allowEditing={false} visible={false} />
                                <Column caption="Item Description-2" dataField="description2" allowEditing={false} visible={false} />
                                <Column caption="Lot Description-1" dataField="lotDescription1" allowEditing={false} visible={false} />
                                <Column caption="Lot Description-2" dataField="lotDescription2" allowEditing={false} visible={false} />
                                <DataGridToolbar>
                                    <DataGridToolbarItem>
                                        <b> Running Total:  {totalFinalInventoryQuantity}</b>
                                    </DataGridToolbarItem>
                                    <DataGridToolbarItem
                                        name="addRowButton"
                                    />
                                    <DataGridToolbarItem location="after">
                                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                    </DataGridToolbarItem>
                                    <DataGridToolbarItem name="exportButton" />
                                    <DataGridToolbarItem name="columnChooserButton" />
                                </DataGridToolbar>
                            </DataGrid>
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(CountResults);
